import { render, staticRenderFns } from "./DeliveryPickup.vue?vue&type=template&id=363deb0e&scoped=true&"
import script from "./DeliveryPickup.vue?vue&type=script&lang=js&"
export * from "./DeliveryPickup.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryPickup.vue?vue&type=style&index=0&id=363deb0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363deb0e",
  null
  
)

export default component.exports